var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistrationSuccesBackgroundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 839.069,
    height: 271.92,
    viewBox: "0 0 839.069 271.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M195.691,335.92h353.5a27.411,27.411,0,0,0,5.827-.625,27.413,27.413,0,0,0,5.827.625h202a27.192,27.192,0,1,0,0-54.384H739.531a27.192,27.192,0,0,1,0-54.384h73.807a27.192,27.192,0,1,0,0-54.384H727.878a27.192,27.192,0,1,0,0-54.384H479.265a27.192,27.192,0,1,0,0-54.384H257.844a27.192,27.192,0,1,0,0,54.384H102.461a27.192,27.192,0,0,0,0,54.384h97.114a27.192,27.192,0,0,1,0,54.384H44.192a27.192,27.192,0,1,0,0,54.384h151.5a27.192,27.192,0,0,0,0,54.384Zm633.186,0a27.192,27.192,0,1,0-27.192-27.192A27.192,27.192,0,0,0,828.877,335.92Z",
    transform: "translate(-17 -64)",
    fill: "#f3f7ff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationSuccesBackgroundIcon);
export default __webpack_public_path__ + "static/media/registration-succes-background-icon.37fac7117151e50da5a78a2248f6c48c.svg";
export { ForwardRef as ReactComponent };